import { useMemo } from 'react';
import Link        from '../../components/link';
import React       from 'react';
import useDialog   from '../../hooks/use_dialog';

export default function DisconnectProfile({ name, profileURL, disconnectProfile }) {
  const buttons = useMemo(() => ([
    {
      text:  'Keep',
      close: true
    },
    {
      text:    'Disconnect',
      close:   true,
      danger:  true,
      bold:    true,
      color:   'red',
      onClick: disconnectProfile
    }
  ]), [ disconnectProfile ]);

  const onClick = useDialog({
    title:   'Disconnect Profile',
    content: `Are you sure you want to disconnect ${name} profile?`,
    buttons
  });

  return (
    <React.Fragment>
      <div className="list block inset">
        <h3>Connected</h3>
        <Link href={profileURL} external>
          <i className="f7-icons">exit</i>
          View profile on {name}
        </Link>
      </div>
      <div className="profile-disconnect list block inset">
        <div className="button danger disconnect-button" onClick={onClick}>Disconnect</div>
      </div>
    </React.Fragment>
  );
}
